import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const divisionMasterDownloadCSVSlice = createSlice({
  name: 'divisionMasterDownloadCSV',
  initialState: { divisionMasterDownloadCSV: initialState },
  reducers: {
    divisionMasterDownloadCSVApi: (state, data) => {
      state.divisionMasterDownloadCSV = data.payload;
    },
  },
});

export const { divisionMasterDownloadCSVApi } = divisionMasterDownloadCSVSlice.actions;

export default divisionMasterDownloadCSVSlice.reducer;
